<template>
  <table-column-element
    v-bind="$attrs"
    v-on="$listeners"
  >
      <template v-slot="scope">
        {{ scope.row[scope.column.property] }}
      </template>
  </table-column-element>
</template>

<script>
export default {
  props: {
    tableColumnType: { type: String, default: 'string' }, // новый параметр
  },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/table-column-string.vue